export default {
    PRIMARY: '#0D298C',
    SECONDARY: '#2A84B9',
    FOOTER: '#0D298C',
    BLACK: '#000000',
    WHITE: '#ffffff',
    TRANSPARENT: "transparent"
}